import styled from 'styled-components';

const ProductCardDescriptionStyled = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12;

  .ProductCardDescription {
  }
`;

export { ProductCardDescriptionStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
